import PopupBasic from 'src/game/components/popups/PopupBasic';
import i18n from 'src/lib/i18n/i18n';
import uiConfig from 'src/lib/ui/config';
import ButtonScaleViewWithText from 'src/lib/ui/components/ButtonScaleViewWithText';
import View from '@play-co/timestep-core/lib/ui/View';
import sounds from 'src/lib/sounds';
import LangBitmapFontTextView from 'src/lib/ui/components/LangBitmapFontTextView';
import { Feature } from 'src/replicant/analytics';
import TeamIntroHero from '../components/TeamIntroHero';
import TeamIntroHeader from '../components/TeamIntroHeader';
import gsap from 'gsap';

import { AssetGroup } from '@play-co/timestep-core';

const ui = uiConfig.buruburu.care.confirmation;

export default class PopupTeamIntro extends PopupBasic {
  private readonly header: TeamIntroHeader;

  constructor(opts: { superview: View; close: (success: boolean) => void }) {
    const offset = -330;
    super({
      superview: opts.superview,
      close: () => {
        opts.close(false);
      },
      ...ui.popup,
      width: 580,
      height: ui.popup.height - offset,
      darkerBg: true,
      tracking: {
        feature: Feature.MATCH2._,
        $subFeature: Feature.MATCH2.TEAM.INTRO_POPUP,
      },
    });

    this.buttonClose.updateOpts({
      x: this.box.style.width + 3,
      scale: 0,
    });
    this.message.removeFromSuperview();
    this.title.getView().removeFromSuperview();
    this.box.updateOpts({ imgScale: 3 });

    this.header = new TeamIntroHeader({
      superview: this.box,
      x: this.box.style.width * 0.5,
    });

    new LangBitmapFontTextView({
      superview: this.box,
      size: 36,
      color: '#FFFFFF',
      font: 'Title',
      localeText: () => i18n('match2.team.intro_message'),
      width: this.box.style.width * 0.85,
      height: 100,
      align: 'center',
      verticalAlign: 'center',
      centerOnOrigin: true,
      x: this.box.style.width * 0.5,
      y: 125,
    });

    new TeamIntroHero({
      superview: this.box,
      x: this.box.style.width * 0.5,
      y: 475,
    });

    new ButtonScaleViewWithText({
      ...ui.okButton,
      x: this.box.style.width * 0.5 - ui.okButton.width * 0.5,
      y: ui.okButton.y - offset - 15,
      superview: this.box,
      localeText: () => i18n('match2.team.intro_cta'),
      onClick: async () => {
        sounds.sfx.play('ok');
        opts.close(true);
      },
      tracking: {
        feature: Feature.MATCH2._,
        $subFeature: Feature.MATCH2.BATTLE_PASS.TUTORIAL_POPUP_CONTINUE,
      },
    });
  }

  protected getAssetsGroup() {
    return new AssetGroup([
      // Header
      'assets/ui/match2/team/team_awning.png',
      'assets/ui/match2/team/team_branch.png',
      'assets/ui/match2/team/team_mascot_1.png',
      'assets/ui/match2/team/team_mascot_2.png',
      'assets/ui/match2/team/team_mascot_3.png',
      'assets/ui/match2/team/team_mascot_4.png',
      `assets/ui/match2/team/team_title_en.png`,
      `assets/ui/match2/team/team_title_ja.png`,
      // Hero
      'assets/ui/match2/team/team_intro_hero_frame.png',
      'assets/ui/match2/team/team_intro_hero_mask.png',
      'assets/ui/match2/team/team_tile_bg.png',
      'assets/ui/match2/team/team_intro_hero_bubbles.png',
      'assets/ui/match2/team/team_intro_hero_overlay.png',
      'assets/ui/match2/common/fx_shine.png',
      'assets/ui/match2/team/team_intro_hero_mascots.png',
    ]);
  }

  public override async fadeIn() {
    super.fadeIn();
    await this.header.show();
    gsap.to(this.buttonClose.style, {
      duration: 0.4,
      scale: 1,
      ease: 'back.out(2)',
    });
  }

  public override async fadeOut() {
    super.fadeOut();
    this.header.killAnimations();
  }
}
